<script setup lang="ts">
import { onMounted, onUpdated, ref } from 'vue';

import { vElementSize } from '@vueuse/components';
import { useResizeObserver } from '@vueuse/core';
import fitty, { type FittyInstance } from 'fitty';

const rootElement = ref<HTMLElement>();

interface Props {
  minSize: number;
  maxSize: number;
}

const props = defineProps<Props>();

let instance: FittyInstance | null = null;

function fit(): void {
  if (instance) {
    instance.fit();
  }
}

onMounted(() => {
  if (rootElement.value) {
    instance = fitty(rootElement.value, { minSize: props.minSize, maxSize: props.maxSize });
  }
});

onUpdated(() => {
  fit();
});

useResizeObserver(rootElement, () => {
  if (instance) {
    instance.fit();
  }
});
</script>

<template>
  <span ref="rootElement" v-element-size="() => fit()" class="ui-fitty">
    <slot />
  </span>
</template>

<style scoped>
.ui-fitty {
  max-width: 100%;
}
</style>
